// Espejo del helper backend (src/common/validateCedulaCR.ts) — mantener en
// sync. Validación suave de cédula CR (spec internal/specs/facturas-v1.md §3.3):
// física 9 dígitos / jurídica 10 dígitos arrancando en 3, con o sin guiones.
// La UI lo usa SOLO para warning amarillo no bloqueante; la decisión de
// guardar nunca depende de este check.

export type CedulaCRValidation = {
  valid: boolean;
  type: "fisica" | "juridica" | null;
};

export function validateCedulaCR(value: string): CedulaCRValidation {
  const trimmed = value.trim();
  if (trimmed === "") return { valid: false, type: null };

  if (!/^[\d-]+$/.test(trimmed)) return { valid: false, type: null };

  const digits = trimmed.replace(/-/g, "");

  if (/^\d{9}$/.test(digits)) {
    return { valid: true, type: "fisica" };
  }
  if (/^3\d{9}$/.test(digits)) {
    return { valid: true, type: "juridica" };
  }
  return { valid: false, type: null };
}
